import backofficeService from '../../api/backoffice';
import publicService from '../../api/public'

export default {
  /**
   * Get list of products
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to products
   */
  getAll(params) {
    return backofficeService.Api().get('sadqaFinancialAid', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  /**
   * Get specific product
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to product
   */
  getById(id, params = {}) {
    return backofficeService.Api().get(`sadqaFinancialAid/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  
  /**
   * Create a product. Will also initiate location data
   * @param {*} data
   */
  create(data) {
    return backofficeService.Api().post('sadqaFinancialAid', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Update specific product
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`sadqaFinancialAid/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Delete product
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`sadqaFinancialAid/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  publicSendTextMessage(data) {
    return backofficeService.Api().post(`sadqaFinancialAid/sendMessage`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  publicGetByCode(code, params) {
    return publicService.Api().get(`/public/sadqaFinancialAid/info/${code}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  publicUpdate(id, key, data) {
    return publicService.Api().put(`/public/sadqaFinancialAid/${id}?key=${key}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

}
